<template>
  <div>
    <el-form label-position="top" label-width="90px">
      <el-form-item label="⚙ 选择办理对象" prop="text" class="user-type">
        <el-radio-group v-model="nodeProps.assignedType">
          <el-radio v-for="t in approvalTypes" :label="t.type" :key="t.type">{{ t.name }}</el-radio>
        </el-radio-group>
        <div v-if="nodeProps.assignedType === 'ASSIGN_USER'">
          <el-button size="mini" icon="el-icon-plus" type="primary" @click="selectUser" round>选择人员</el-button>
          <member-items v-model="nodeProps.assignedUser"/>
        </div>
        <div v-else-if="nodeProps.assignedType === 'SELF_SELECT'">
          <el-radio-group size="mini" v-model="nodeProps.selfSelect.multiple">
            <el-radio-button :label="false">自选一个人</el-radio-button>
            <el-radio-button :label="true">自选多个人</el-radio-button>
          </el-radio-group>
        </div>
        <div v-else-if="nodeProps.assignedType === 'LEADER_TOP'">
          <el-divider/>
          <el-form-item label="办理终点" prop="text" class="approve-end">
            <el-radio-group v-model="nodeProps.leaderTop.endCondition">
              <el-radio label="TOP">直到最上层主管</el-radio>
              <el-radio label="LEAVE">不超过发起人的</el-radio>
            </el-radio-group>
            <div class="approve-end-leave" v-if="nodeProps.leaderTop.endCondition === 'LEAVE'">
              <span>第 </span>
              <el-input-number :min="1" :max="20" :step="1" size="mini" v-model="nodeProps.leaderTop.level"/>
              <span> 级主管</span>
            </div>
          </el-form-item>
        </div>
        <div v-else-if="nodeProps.assignedType === 'LEADER'">
          <el-divider/>
          <el-form-item label="指定主管" prop="text">
            <span>发起人的第 </span>
            <el-input-number :min="1" :max="20" :step="1" size="mini"
                             v-model="nodeProps.leader.level"></el-input-number>
            <span> 级主管</span>
            <div style="color: #409EFF; font-size: small;">👉 直接主管为 第 1 级主管</div>
          </el-form-item>
        </div>
        <div v-else-if="nodeProps.assignedType === 'ROLE'">
          <el-button size="mini" icon="el-icon-plus" type="primary" @click="selectRole" round>选择系统角色</el-button>
          <member-items v-model="nodeProps.role"/>
        </div>
        <div v-else-if="nodeProps.assignedType === 'FORM_USER'">
          <el-form-item label="选择表单联系人项" prop="text" class="approve-end">
            <el-select style="width: 80%;" size="small" v-model="nodeProps.formUser" placeholder="请选择包含联系人的表单项">
              <el-option v-for="op in forms" :label="op.title" :value="op.id" :key="op.id"></el-option>
            </el-select>
          </el-form-item>
        </div>
        <div v-else>
          <span class="item-desc">发起人自己作为办理人进行办理</span>
        </div>
      </el-form-item>

      <el-divider></el-divider>
      <el-form-item label="👤 办理人为空时" prop="text" class="line-mode">
        <el-radio-group v-model="nodeProps.nobody.handler">
          <el-radio label="TO_PASS">自动办理</el-radio>
          <el-radio label="TO_ADMIN">转交办理管理员</el-radio>
          <el-radio label="TO_USER">转交到指定人员</el-radio>
        </el-radio-group>

        <div style="margin-top: 10px" v-if="nodeProps.nobody.handler === 'TO_USER'">
          <el-button size="mini" icon="el-icon-plus" type="primary" @click="selectNoSetUser" round>选择人员</el-button>
          <member-items v-model="nodeProps.nobody.assignedUser"/>
        </div>
      </el-form-item>

      <div v-if="showMode">
        <el-divider/>
        <el-form-item label="👩‍👦‍👦 多人办理时办理方式" prop="text" class="approve-mode">
          <el-radio-group v-model="nodeProps.mode">
            <el-radio label="NEXT">会签 （按选择顺序办理，每个人都要办理）</el-radio>
            <el-radio label="AND">会签（可同时办理，每个人都要办理）</el-radio>
            <el-radio label="OR">或签（有一人办理即可）</el-radio>
          </el-radio-group>
        </el-form-item>
      </div>

      <el-divider>高级设置</el-divider>
      <el-form-item label="⏱ 办理期限（为 0 则不生效）" prop="timeLimit">
        <el-input style="width: 180px;" placeholder="时长" size="small" type="number"
                  v-model="nodeProps.timeLimit.timeout.value">
          <el-select style="width: 75px;" v-model="nodeProps.timeLimit.timeout.unit" slot="append" placeholder="请选择">
            <el-option label="天" value="D"></el-option>
            <el-option label="小时" value="H"></el-option>
          </el-select>
        </el-input>
      </el-form-item>
      <el-form-item label="办理期限超时后执行" prop="level" v-if="nodeProps.timeLimit.timeout.value > 0">
        <el-radio-group v-model="nodeProps.timeLimit.handler.type">
          <el-radio label="PASS">自动办理</el-radio>
          <el-radio label="NOTIFY">发送催办提醒</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-divider>更多配置</el-divider>
      <div class="more-config-item">
        <div class="more-config-label">
          ✍️ 办理时是否签字
          <el-tooltip content="如果全局设置了需要签字，则此处不生效" placement="top" effect="dark">
            <i class="el-icon-question more-config-tip"></i>
          </el-tooltip>
        </div>
        <el-switch inactive-text="不用" active-text="需要" v-model="nodeProps.sign"></el-switch>
      </div>
      <div class="more-config-item">
        <div class="more-config-label">
          📋 办理时填写表单
          <el-tooltip content="如果此处配置了办理表单，将覆盖全局的配置" placement="top" effect="dark">
            <i class="el-icon-question more-config-tip"></i>
          </el-tooltip>
        </div>
        <ApprovalFormConfig v-model="nodeProps.formJson" />
        <div class="more-config-desc">办理人需要填写此表单</div>
      </div>
      <div class="more-config-item">
        <div class="more-config-label">
          ⚙️ 办理操作配置
          <el-tooltip content="如果全局已经勾选了下方的操作，此处无需再勾选" placement="top" effect="dark">
            <i class="el-icon-question more-config-tip"></i>
          </el-tooltip>
        </div>
        <div class="node-action-wrap">
          <div class="node-action-item" v-for="action in approverActions" :key="action.key">
            <el-checkbox v-model="nodeProps.actions[action.key]">{{ action.label }}</el-checkbox>
            <el-tooltip :content="action.desc" placement="top" effect="dark">
              <i class="el-icon-question node-action-tip"></i>
            </el-tooltip>
          </div>
        </div>
      </div>
    </el-form>
    <member-picker :title="pickerTitle" multiple :type="memberPickerType" ref="memberPicker" :selected="memberPickerSelected"
                   @ok="selected"/>
  </div>
</template>

<script>
import MemberPicker from '../../common/MemberPicker'
import MemberItems from '../MemberItems'
import ApprovalFormConfig from '../common/ApprovalFormConfig'

export default {
  name: 'ApprovalNodeConfig',
  inject: ['$workflow'],
  components: {MemberPicker, MemberItems, ApprovalFormConfig},
  props: {
    config: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data () {
    return {
      showMemberSelect: false,
      memberPickerSelected: [],
      memberPickerType: 'user',
      memberPickerTo: null, // 'assignedUser' | 'role' | 'nobodyUser'
      approvalTypes: [
        {name: '指定人员', type: 'ASSIGN_USER'},
        // {name: '发起人自选', type: 'SELF_SELECT'},
        // {name: '连续多级主管', type: 'LEADER_TOP'},
        // {name: '主管', type: 'LEADER'},
        {name: '角色', type: 'ROLE'}
        // {name: '发起人自己', type: 'SELF'},
        // {name: '表单内联系人', type: 'FORM_USER'}
      ],
      approverActions: [
        { key: 'urge', label: '催办', desc: '仅对已处理且未结束的流程有效，审核人可催办提醒后续节点处理人' },
        { key: 'comment', label: '评论', desc: '当前节点处理人可以添加评论信息' },
        { key: 'transfer', label: '转办', desc: '当前节点处理人，将操作权限转给别人处理，处理完后进入下一节点（自己不再处理）' },
        { key: 'delegate', label: '委派', desc: '当前节点处理人，将自己的主办或者经办权限转移委托至别的用户代为处理，处理完后回到当前处理人手中，并由当前处理人处理完后进入下一节点' },
        { key: 'addMulti', label: '加签', desc: '当前节点处理人，需要让其他人核对流程' }
      ]
    }
  },
  computed: {
    nodeProps () {
      return this.$workflow.selectedNode.props
    },
    select () {
      if (this.nodeProps.assignedType === 'ROLE') {
        return this.config.role || []
      }
      return this.config.assignedUser || []
    },
    forms () {
      return this.$workflow.design.formItems.filter(f => {
        return f.name === 'UserPicker'
      })
    },
    pickerTitle () {
      switch (this.memberPickerType) {
        case 'user':
          return '请选择人员'
        case 'role':
          return '请选择系统角色'
        default:
          return null
      }
    },
    showMode () {
      switch (this.nodeProps.assignedType) {
        case 'ASSIGN_USER':
          return this.nodeProps.assignedUser.length > 0
        case 'SELF_SELECT':
          return this.nodeProps.selfSelect.multiple
        case 'LEADER_TOP':
          return this.nodeProps.formUser !== ''
        case 'FORM_USER':
          return true
        case 'ROLE':
          return true
        default:
          return false
      }
    }
  },
  methods: {
    selectUser () {
      this.memberPickerSelected = this.nodeProps.assignedUser || []
      this.memberPickerType = 'user'
      this.memberPickerTo = 'assignedUser'
      this.$refs.memberPicker.show()
    },
    selectNoSetUser () {
      this.memberPickerSelected = this.nodeProps.nobody.assignedUser || []
      this.memberPickerType = 'user'
      this.memberPickerTo = 'nobodyUser'
      this.$refs.memberPicker.show()
    },
    selectRole () {
      this.memberPickerSelected = this.nodeProps.role || []
      this.memberPickerType = 'role'
      this.memberPickerTo = 'role'
      this.$refs.memberPicker.show()
    },
    selected (select) {
      switch (this.memberPickerTo) {
        case 'assignedUser':
          this.nodeProps.assignedUser = select
          break
        case 'role':
          this.nodeProps.role = select
          break
        case 'nobodyUser':
          this.nodeProps.nobody.assignedUser = select
          break
      }
    },
    initNodeActions () {
      if (!this.nodeProps.actions) {
        this.$set(this.nodeProps, 'actions', {})
      }
      this.approverActions.forEach(action => {
        if (this.nodeProps.actions[action.key] === undefined) {
          this.$set(this.nodeProps.actions, action.key, false)
        }
      })
    }
  },
  watch: {
    'nodeProps': {
      handler () {
        this.initNodeActions()
      },
      immediate: true
    }
  }
}
</script>

<style lang="scss" scoped>
.user-type {
  ::v-deep .el-radio {
    width: 110px;
    margin-top: 10px;
    margin-bottom: 20px;
  }
}

::v-deep .line-mode {
  .el-radio {
    width: 150px;
    margin: 5px;
  }
}

::v-deep .el-form-item__label {
  line-height: 25px;
}

::v-deep .approve-mode {
  .el-radio {
    float: left;
    width: 100%;
    display: block;
    margin-top: 15px;
  }
}

::v-deep .approve-end {
  position: relative;

  .el-radio-group {
    width: 160px;
  }

  .el-radio {
    margin-bottom: 5px;
    width: 100%;
  }

  .approve-end-leave {
    position: absolute;
    bottom: -5px;
    left: 150px;
  }
}

::v-deep .el-divider--horizontal {
  margin: 10px 0;
}

.more-config-item {
  margin-top: 20px;

  .more-config-label {
    font-size: 13px;
    font-weight: 500;
    color: #303133;
    margin-bottom: 8px;
    display: flex;
    align-items: center;
    gap: 4px;

    .more-config-tip {
      color: #909399;
      cursor: help;
      &:hover {
        color: #409eff;
      }
    }
  }

  .more-config-desc {
    margin-top: 5px;
    font-size: 12px;
    color: #909399;
  }
}

.node-action-wrap {
  border: 1px solid #dcdfe6;
  background-color: #F3F5F7;
  border-radius: 6px;
  padding: 10px 16px;
  display: flex;
  flex-wrap: wrap;
  gap: 10px 20px;

  .node-action-item {
    display: flex;
    align-items: center;
    min-width: 90px;

    ::v-deep .el-checkbox__label {
      font-size: 13px;
    }

    .node-action-tip {
      margin-left: 4px;
      color: #909399;
      cursor: help;
      &:hover {
        color: #409eff;
      }
    }
  }
}
</style>
